import { render, staticRenderFns } from "./ActivityZone.vue?vue&type=template&id=6665227e&scoped=true"
import script from "./ActivityZone.vue?vue&type=script&lang=js"
export * from "./ActivityZone.vue?vue&type=script&lang=js"
import style0 from "./ActivityZone.vue?vue&type=style&index=0&id=6665227e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665227e",
  null
  
)

export default component.exports